(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ResultSeriesDeleteController',ResultSeriesDeleteController);

    ResultSeriesDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResultSeries'];

    function ResultSeriesDeleteController($uibModalInstance, entity, ResultSeries) {
        var vm = this;

        vm.resultSeries = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResultSeries.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
